export enum PostType {
  USER = 'USER',
  FOOD = 'FOOD',
  PEOPLE = 'PEOPLE',
  PLATE_FAVORITE = 'PLATE_FAVORITE',
  PLATE_EATEN = 'PLATE_EATEN',
  PLACE_INSIDE = 'PLACE_INSIDE',
  PLACE_OUTSIDE = 'PLACE_OUTSIDE'
}
